import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { AiAgentLayout } from './layouts/ai-agent-layout/ai-agent-layout';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'ai-agent' },
  {
    path: 'ai-agent',
    component: AiAgentLayout,
      canActivate: [authGuard],
    children: [
      /** Home: no conversation id until the user sends the first message (API returns id). */
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./views/ai-agent/ai-agent').then((m) => m.AiAgent),
      },
      {
        path: ':conversationId',
        loadComponent: () => import('./views/ai-agent/ai-agent').then((m) => m.AiAgent),
      },
    ],
  },
  {
    path: 'workflow-builder',
    component: AiAgentLayout,
    /** Session skipped in development only — see `authGuard`. */
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./views/ai-agent/components/agent-workflow-builder/agent-workflow-builder').then(
            (m) => m.AgentWorkflowBuilder,
          ),
      },
    ],
  },
  {
    path: 'authorization/:id',
    loadComponent: () =>
      import('./views/authorization/authorization').then((m) => m.Authorization),
    data: { layout: 'blank' },
  },
  {
    path: 'page-not-found',
    loadComponent: () =>
      import('./views/page-not-found/page-not-found').then((m) => m.PageNotFound),
    data: { layout: 'blank' },
  },
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./views/access-denied/access-denied').then((m) => m.AccessDenied),
    data: { layout: 'blank' },
  },
];
